import * as React from 'react';
import Loader from '.';
import './TableLoader.scss';

export default function TableLoader(props: { loading: boolean }) {
    return props.loading ? (
        <div
            className="tableLoader"
        >
            <div>
                <Loader />
            </div>
        </div>
    ) : null;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Loader/TableLoader.tsx